"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
(0, jquery_1.default)(function () {
    // Hookup listeners for the main menu mobile bar.
    (0, jquery_1.default)('.menu-button-wrapper').on("click", function () {
        var $mainMenuContainer = (0, jquery_1.default)('#main-menu-container');
        var duration = 200;
        if ($mainMenuContainer.is(':visible')) {
            $mainMenuContainer.hide(duration);
        }
        else {
            $mainMenuContainer.show(duration);
        }
    });
});
